var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
import {loading} from "../include/module";
loading();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// アニメーション
import {animationFire} from "../include/module";
animationFire();

//スタッフ・キャストのコメントモーダル
const commentModal = () => {
  const $modal = $('.staff_cast_Modal');
  const $content = $('.staff_cast_Modal-Content');
  const $comment = $('.js-staff_cast_Modal');
  const $setArea = $('#staff_cast_Modal-Content').children('.content');
  // open
  $comment.on('click', function(){
    const dataID = $(this).attr('data-id');
    $.ajax({
      url: '/wp/wp-content/themes/anime_heros_ultraman/assets/js/staff_cast/comment.json',
      dataType: 'json',
      cache: false,
      success : function(data){

        const allData = data;
        const filterData = allData.filter(function(item, index){
                if (item.itemID == dataID) return true;
              });
        const roleJa = filterData[0].itemRoleJa;
        const roleEn = filterData[0].itemRoleEn;
        const nameJa = filterData[0].itemNameJa;
        const commentJa = filterData[0].itemCommentJa;
        const nameEn = filterData[0].itemNameEn;
        const commentEn = filterData[0].itemCommentEn;
        const image = filterData[0].itemImage;
        let element;

        if(dataID === 'kamiyama-kenji' || dataID === 'aramaki-shinji' || dataID === 'kawana-motoki' || dataID === 'kimura-ryohei' || dataID === 'eguchi-takuya' || dataID === 'han-megumi' || dataID === 'tanaka-hideyuki' || dataID === 'morohoshi-sumire' || dataID === 'uo-ken' || dataID === 'ushiyama-shigeru' || dataID === 'takeuchi-ryota' || dataID === 'hanawa-eiji' || dataID === 'sekido-hirokazu' || dataID === 'tsuda-kenjiro' || dataID === 'shiraishi-minoru' || dataID === 'soze-kaiji' || dataID === 'yamazaki-katsuyuki' || dataID === 'kasahara-shinji' || dataID === 'shibai-haruka' || dataID === 'ogawa-teruaki' || dataID === 'soze-kaiji_2'){
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body with-image"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + image  + '.jpg"></div><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div></div>'
        }else if(dataID === 'music'){
          const profileJa = filterData[0].itemProfileJa;
          const profileEn = filterData[0].itemProfileEn;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body"><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div><div class="profile"><h3>PROFILE</h3><p class="ja">' + profileJa + '</p><p class="en">' + profileEn + '</p></div></div>'
        }else if(dataID === 'oldcodex'){
          const commenter = filterData[0].itemCommenter;
          const commentJa_2 = filterData[0].itemCommentJa_2;
          const commenter2 = filterData[0].itemCommenter2;
          const commentJa2 = filterData[0].itemCommentJa2;
          const commentJa2_2 = filterData[0].itemCommentJa2_2;
          const commentEn2 = filterData[0].itemCommentEn2;
          const profileJa = filterData[0].itemProfileJa;
          const profileEn = filterData[0].itemProfileEn;
          const songTitle = filterData[0].itemSongTitle;
          const songTitle2 = filterData[0].itemSongTitle2;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body oldcodex"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + dataID  + '_2.png"><p class="song-title">' + songTitle2 + '</p></div><div class="comment"><h3>' + commenter + '</h3><p class="ja">' + commentJa_2 + '</p></div><div class="comment"><h3>' + commenter2 + '</h3><p class="ja">' + commentJa2_2 + '</p></div></div><div class="body oldcodex"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + dataID  + '.png"><p class="song-title">' + songTitle + '</p></div><div class="comment"><h3>' + commenter + '</h3><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div><div class="comment"><h3>' + commenter2 + '</h3><p class="ja">' + commentJa2 + '</p><p class="en">' + commentEn2 + '</p></div><div class="profile"><h3>PROFILE</h3><p class="ja">' + profileJa + '</p><p class="en">' + profileEn + '</p></div></div>'
        }else if(dataID === 'void_chords'){
          const songTitle = filterData[0].itemSongTitle;
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body oldcodex"><div class="image"><img src="/wp/wp-content/themes/anime_heros_ultraman/assets/images/common/staff_cast/img_' + dataID  + '.png"><p class="song-title">' + songTitle + '</p></div><div class="comment"><p class="ja">' + commentJa + '</p></div></div>'
        }else{
          element = '<dl><dt><span class="ja">' + roleJa + '</span><span class="en">' + roleEn + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span><span class="en">' + nameEn + '</span></p></div></dd></dl><div class="body"><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div></div>'
        }

        $(element).appendTo($setArea);

        // else if(dataID === 'yamazaki-katsuyuki'){
        //   element = '<dl><dt><span class="ja">' + roleJa + '</span></dt><dd><div><p class="name"><span class="ja">' + nameJa + '</span></p></div></dd></dl><div class="body"><div class="comment"><p class="ja">' + commentJa + '</p><p class="en">' + commentEn + '</p></div></div>'
        // }
      }
    });


    $modal.stop().fadeIn(400);
    return false;
  });
  //close
  $('.staff_cast_Modal-Overlay,.staff_cast_Modal-Close').on('click', function(){
    $modal.stop().fadeOut(400, function(){
      $setArea.children().remove();
    });
  });
};
commentModal();



// WEBPACK FOOTER //
// ./src/assets/js/staff_cast/script.js